import InfiniteScroll from 'react-infinite-scroll-component';
import { ANNOUNCEMENT_SCROLL_TARGET } from '../../../containers/projectDetails/projectDetailConstants';
import Announcement from '../announcement/announcement';
import moment from 'moment';
import { useState } from 'react';

interface IAnnouncement {
  id: string;
  name: string;
  isImportant?: boolean;
  createdByUserName: string;
  authorId: string;
  status?: string;
  details?: string;
  modifiedDateTime?: string;
  createdOn?: string;
  modifiedOn?: string;
  modifiedByUserName?: string;
}
interface IAnnouncementTabPanelProps {
  announcements: Array<IAnnouncement>;
  isProjectAdmin: boolean;
  deleteAnnouncement: Function;
  editAnnouncement: Function;
  makeAnnouncementRead: Function;
}
export const AnnouncementTabPanel: React.FC<IAnnouncementTabPanelProps> = ({
  announcements,
  isProjectAdmin,
  deleteAnnouncement,
  editAnnouncement,
  makeAnnouncementRead,
}) => {
  const [announcementsData, setAnnouncementsData] = useState<
    Array<IAnnouncement>
  >(
    announcements?.sort(
      (a, b) =>
        moment(b.modifiedDateTime).valueOf() -
        moment(a.modifiedDateTime).valueOf()
    ) || []
  );
  

  const handleAnnouncementRead = (announcementId: string) => {
    const updatedAnnouncements = announcementsData.map((announcement) => {
      if (announcement.id === announcementId) {
        return { ...announcement, status: 'Read' };
      }
      return announcement;
    })
    setAnnouncementsData(updatedAnnouncements);
    makeAnnouncementRead(announcementId);
  }

  return (
    <>
      <InfiniteScroll
        dataLength={announcementsData?.length}
        next={() => {}}
        hasMore={false}
        loader={''}
        scrollableTarget={ANNOUNCEMENT_SCROLL_TARGET}
      >
        {announcementsData?.length > 0
          ? announcementsData?.map((announcement: IAnnouncement) => (
              <Announcement
                key={`announcement_${announcement.id}`}
                id={announcement.id}
                title={announcement.name}
                description={announcement.details ?? ''}
                isImportant={announcement.isImportant}
                createdBy={announcement.createdByUserName}
                createdDate={announcement.createdOn ?? ''}
                modifiedDate={announcement.modifiedOn ?? ''}
                isProjectAdmin={isProjectAdmin}
                authorId={announcement.authorId}
                deleteAnnouncement={deleteAnnouncement}
                editAnnouncement={editAnnouncement}
                status={announcement.status}
                makeAnnouncementRead={handleAnnouncementRead}
                modifiedByUserName={announcement.modifiedByUserName ?? ''}
              />
            ))
          : ''}
      </InfiniteScroll>
    </>
  );
};

